import { ITime } from './animation';

export enum CreativeType {
    Animated
}


export interface IPreloadImage {
    frames: number[];
    format: 'jpg' | 'gif' | 'png';
    quality: number;
}

export interface IGifExport {
    frames: ITime[];
    show: boolean;
}

export enum SocialPlacementType {
    Instagram,
    Facebook,
    Messenger,
}

export interface ISocialGuide {
    placement: SocialPlacementType;
    overlay: boolean;
    guidelines: boolean;
}
